import { html } from 'lit-html';
import { ItemJsEnv } from '../../models/item_js_env';
import { CarouselItems } from '../../../core/views/pc/carousel_item/carousel_items';
import { Env } from '../../../core/env';
import { isSoloare } from '../../../core/models/js_env';

/**
 * おすすめ関連商品エリア
 * @param model 商品詳細画面情報
 */
// 商品詳細画面では、このエリアはサーバ側でレンダリングする。ここは非同期処理エリアのサンプルとして参考
export const InflowWordItems = (model: ItemJsEnv) => html`
   <div class="o-colBox -margin24 o-recommendArea_head">
     <div class="a-colitem">
       <div class="o-colBox -margin24 recom_Dtkeyword">
         <div class="a-heading -typeh3">
           <h2 class="a-heading_text">${model.categoryTree.mCategoryName}の検索結果</h2>
         </div>
         <p class="a-text">
           <a href="${UrlBase()}m/${model.categoryTree.llCategoryCode}-${model.categoryTree.lCategoryCode}-${model.categoryTree.mCategoryCode}/" class="a-textlink u-dn-sp">
             “${model.categoryTree.mCategoryName}”の検索結果${model.inflowWordItemsTotal}件
           </a>
         </p>
       </div>
     </div>
   </div>
  ${CarouselItems(model.inflowWordItems, model.isLogin, "InflowWordsItems-carousel", undefined, "recom_Dtkeyword")}
`;

export const UrlBase = () => {
  if (isSoloare(Env.SITE_TYPE)) {
    return Env.SETTING.soloareFront.urlBase;
  }
  return Env.SETTING.clubFront.urlBase;
};
